<template>
  <svg
    v-if="variant === 'legacy'"
    class="tw-animate-spin"
    :width="size"
    :height="size"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.10051 6.1005C7.66275 4.53826 9.57255 3.36793 11.6738 2.68521C13.775 2.00248 16.0079 1.82675 18.1901 2.17236C20.3722 2.51798 22.4416 3.37514 24.229 4.67376C26.0164 5.97238 27.4711 7.67559 28.4741 9.64414C29.4771 11.6127 30 13.7907 30 16C30 18.2093 29.4771 20.3873 28.4741 22.3559C27.4711 24.3244 26.0164 26.0276 24.229 27.3262C22.4416 28.6249 20.3722 29.482 18.1901 29.8276"
      stroke="currentColor"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    v-else
    class="tw-animate-spin"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="outer"
      :class="pathClass"
      d="M22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2C10.6868 2 9.38642 2.25866 8.17316 2.76121C6.95991 3.26375 5.85752 4.00035 4.92893 4.92893C4.00034 5.85752 3.26375 6.95991 2.7612 8.17317C2.25866 9.38642 2 10.6868 2 12C2 13.3132 2.25866 14.6136 2.76121 15.8268C3.26375 17.0401 4.00035 18.1425 4.92894 19.0711C5.85752 19.9997 6.95991 20.7363 8.17317 21.2388C9.38643 21.7413 10.6868 22 12 22C13.3132 22 14.6136 21.7413 15.8268 21.2388C17.0401 20.7362 18.1425 19.9997 19.0711 19.0711C19.9997 18.1425 20.7363 17.0401 21.2388 15.8268C21.7413 14.6136 22 13.3132 22 12Z"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      class="inner"
      :class="pathClass"
      d="M22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script lang="ts" setup>
const props = defineProps({
  // size in px
  size: {
    type: [String, Number],
    default: 32,
  },
  // width in pixels
  strokeWidth: {
    type: [String, Number],
    default: 4,
  },
  // Variants: 'legacy', 'default', or 'dark'
  variant: {
    type: String as PropType<'legacy' | 'default' | 'dark'>,
    default: 'legacy',
  },
});

const pathClass =
  props.variant === 'default' ? '--default' : props.variant === 'dark' ? '--dark' : '';
</script>

<style scoped>
.outer.--default {
  @apply tw-bg-secondary-bg-dark;
  stroke: var(--color-secondary-bg-dark);
}
.inner.--default {
  @apply tw-bg-primary-dark;
  stroke: var(--color-primary-dark);
}

.outer.--dark {
  @apply tw-bg-primary-medium;
  stroke: var(--color-primary-medium);
}
.inner.--dark {
  @apply tw-bg-secondary-bg-dark;
  stroke: var(--color-secondary-bg-dark);
}
</style>
